/* eslint-disable react/jsx-filename-extension */
import { h, Fragment } from 'preact'
import { useSize } from '@utils/dom'

export default function HeaderLinks({
    headerLinks,
    wishlistQuantity,
    cartQuantity,
    customerLinks,
}) {
    const { isDesktop } = useSize()
    const isCartPage = window.location.pathname === '/cart'

    const {
        isAuthenticated,
        shoppingCartEnabled,
        wishlistEnabled
    } = headerLinks

    const route = (path) => {
        window.location.href = path
    }

    return (
        <div
            className="headerLinks header-links"
            style={{ position: 'relative' }}
        >
            <div
                class="menu-item--toggle-search"
                className="header-link"
                data-drawer-toggle="search"
            >
                <svg
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 2.5a7.5 7.5 0 0 1 5.964 12.048l4.743 4.745a1 1 0 0 1-1.32 1.497l-.094-.083-4.745-4.743A7.5 7.5 0 1 1 10 2.5Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z"
                        fill="#000000"
                    />
                </svg>
            </div>

            <div
                className="header-link menu-item--toggle-menu --mobile-only"
                data-drawer-toggle="menu"
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.75254 17.9997H21.2525C21.6667 17.9997 22.0025 18.3355 22.0025 18.7497C22.0025 19.1294 21.7204 19.4432 21.3543 19.4928L21.2525 19.4997H2.75254C2.33832 19.4997 2.00254 19.1639 2.00254 18.7497C2.00254 18.37 2.28469 18.0562 2.65077 18.0065L2.75254 17.9997H21.2525H2.75254ZM2.75254 11.5027H21.2525C21.6667 11.5027 22.0025 11.8385 22.0025 12.2527C22.0025 12.6324 21.7204 12.9462 21.3543 12.9959L21.2525 13.0027H2.75254C2.33832 13.0027 2.00254 12.6669 2.00254 12.2527C2.00254 11.873 2.28469 11.5592 2.65077 11.5095L2.75254 11.5027H21.2525H2.75254ZM2.75168 5.00293H21.2517C21.6659 5.00293 22.0017 5.33872 22.0017 5.75293C22.0017 6.13263 21.7195 6.44642 21.3535 6.49608L21.2517 6.50293H2.75168C2.33746 6.50293 2.00168 6.16714 2.00168 5.75293C2.00168 5.37323 2.28383 5.05944 2.64991 5.00978L2.75168 5.00293H21.2517H2.75168Z"
                        fill="#212121"
                    />
                </svg>
            </div>

            {/* <TopMenuDrawerToggle
                onClick={() => toggleDrawer()}
                visible={!isDesktop}
            /> */}

            {isAuthenticated ? (
                <Fragment>
                    <div
                        className={`menu-item--my-account--popout hidden`}
                        data-drawer-name="account"
                        data-animate-in="fade-in"
                        data-animate-out="fade-out"
                    >
                        {customerLinks?.account && (
                            <a
                                href={
                                    customerLinks?.account?.url ||
                                    'customer/info'
                                }
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                <strong>
                                    {customerLinks?.account?.text ||
                                        'topmenu.account'}
                                </strong>
                                <svg
                                    width="24"
                                    height="24"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.704 4.284a1 1 0 1 0-1.403 1.424L17.67 11H4a1 1 0 1 0 0 2h13.665L12.3 18.285a1 1 0 0 0 1.403 1.424l6.925-6.822a1.25 1.25 0 0 0 0-1.78l-6.925-6.823Z"
                                        fill="#000000"
                                    />
                                </svg>
                            </a>
                        )}

                        <div className="customer-links">
                            {customerLinks?.addresses && (
                                <a
                                    href={
                                        customerLinks?.addresses?.url ||
                                        'customer/addresses'
                                    }
                                >
                                    {customerLinks?.addresses?.text ||
                                        'topmenu.addresses'}
                                </a>
                            )}

                            {customerLinks?.orders && (
                                <a
                                    href={
                                        customerLinks?.orders?.url ||
                                        'customer/orders'
                                    }
                                >
                                    {customerLinks?.orders?.text ||
                                        'topmenu.orders'}
                                </a>
                            )}
                        </div>

                        {customerLinks?.logout && (
                            <a
                                className="logout-link"
                                href={customerLinks?.logout?.url}
                            >
                                {customerLinks?.logout?.text ||
                                    'topmenu.logout'}
                            </a>
                        )}
                    </div>

                    <div
                        data-drawer-toggle="account"
                        id="menu-item--my-account"
                        className="header-link"
                        style={{
                            position: 'relative',
                        }}
                    // onMouseLeave={() => setAccountHovered(false)}
                    >
                        <div
                            id="account-chevron"
                            style={{
                                position: 'absolute',
                                bottom: '0',
                                right: '0',
                                borderRadius: '2rem',
                                width: '14px',
                                height: '14px',
                                background: '#eee',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // transform: !accountHovered ? 'none' : 'rotateZ(180deg)',
                            }}
                        >
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    minHeight: 'unset',
                                    minWidth: 'unset',
                                    display: 'flex',
                                }}
                            >
                                <path
                                    d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z"
                                    fill="#212121"
                                />
                            </svg>
                        </div>
                        <a
                            href="/customer/info"
                            // onClick={() => route('/customerinfo')}
                            onClick={e => e.preventDefault()}
                            className="lnk-account"
                            title="My account"
                            data-modal="account"
                        >
                            <svg
                                width="24"
                                height="24"
                                fill="none"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M17.754 14a2.249 2.249 0 0 1 2.25 2.249v.575c0 .894-.32 1.76-.902 2.438-1.57 1.834-3.957 2.739-7.102 2.739-3.146 0-5.532-.905-7.098-2.74a3.75 3.75 0 0 1-.898-2.435v-.577a2.249 2.249 0 0 1 2.249-2.25h11.501Zm0 1.5H6.253a.749.749 0 0 0-.75.749v.577c0 .536.192 1.054.54 1.461 1.253 1.468 3.219 2.214 5.957 2.214s4.706-.746 5.962-2.214a2.25 2.25 0 0 0 .541-1.463v-.575a.749.749 0 0 0-.749-.75ZM12 2.004a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"
                                    fill="#000000"
                                />
                            </svg>
                        </a>
                    </div>
                </Fragment>
            ) : (
                <div id="menu-item--sign-in" className="header-link">
                    <a
                        href="/login"
                        data-modal="account"
                        onClick={() => route('/login')}
                    >
                        <svg
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M17.754 14a2.249 2.249 0 0 1 2.25 2.249v.575c0 .894-.32 1.76-.902 2.438-1.57 1.834-3.957 2.739-7.102 2.739-3.146 0-5.532-.905-7.098-2.74a3.75 3.75 0 0 1-.898-2.435v-.577a2.249 2.249 0 0 1 2.249-2.25h11.501Zm0 1.5H6.253a.749.749 0 0 0-.75.749v.577c0 .536.192 1.054.54 1.461 1.253 1.468 3.219 2.214 5.957 2.214s4.706-.746 5.962-2.214a2.25 2.25 0 0 0 .541-1.463v-.575a.749.749 0 0 0-.749-.75ZM12 2.004a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"
                                fill="#000000"
                            />
                        </svg>
                    </a>
                </div>
            )}

            {wishlistEnabled && (
                <Fragment>
                    <div
                        id="menu-item--wishlist"
                        className="header-link"
                        data-drawer-toggle="wishlist"
                    >
                        <div className="link">
                            <svg
                                width={48}
                                height={48}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12.8199 5.57912L11.9992 6.40163L11.1759 5.57838C9.07688 3.47931 5.67361 3.47931
                                    3.57455 5.57838C1.47548 7.67744 1.47548 11.0807 3.57455 13.1798L11.4699 21.0751C11.7628
                                    21.368 12.2377 21.368 12.5306 21.0751L20.432 13.1783C22.5264 11.0723 22.53 7.67857
                                    20.4306 5.57912C18.3277 3.47623 14.9228 3.47623 12.8199 5.57912ZM19.3684 12.1206L12.0002
                                    19.4842L4.63521 12.1191C3.12192 10.6058 3.12192 8.15232 4.63521 6.63904C6.14849 5.12575
                                    8.602 5.12575 10.1153 6.63904L11.4727 7.99648C11.7706 8.29435 12.2553 8.28854 12.5459
                                    7.98363L13.8806 6.63978C15.3977 5.12268 17.8528 5.12268 19.3699 6.63978C20.8836 8.15343
                                    20.881 10.5997 19.3684 12.1206Z"
                                    fill="#212121"
                                />
                            </svg>

                            <span className="item-quantity">
                                {wishlistQuantity}
                            </span>
                        </div>
                    </div>
                </Fragment>
            )}

            {shoppingCartEnabled && (
                <div
                    id="menu-item--cart"
                    className="header-link"
                    data-drawer-toggle="cart"
                    style={{
                        pointerEvents: isCartPage ? 'none' : 'all',
                        opacity: isCartPage ? '0.5' : '1',
                        position: isCartPage ? 'relative' : 'initial',
                    }}
                >
                    <div className="link">
                        <svg
                            width="48"
                            height="48"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.5 4.25C2.5 3.83579 2.83579 3.5 3.25 3.5H3.80826C4.75873 3.5 5.32782 4.13899 5.65325 4.73299C5.87016 5.12894 6.02708 5.58818 6.14982 6.00395C6.18306 6.00134 6.21674 6 6.2508 6H18.7481C19.5783 6 20.1778 6.79442 19.9502 7.5928L18.1224 14.0019C17.7856 15.1832 16.7062 15.9978 15.4779 15.9978H9.52977C8.29128 15.9978 7.2056 15.1699 6.87783 13.9756L6.11734 11.2045L4.85874 6.95578L4.8567 6.94834C4.701 6.38051 4.55487 5.85005 4.33773 5.4537C4.12686 5.0688 3.95877 5 3.80826 5H3.25C2.83579 5 2.5 4.66421 2.5 4.25ZM7.57283 10.8403L8.32434 13.5786C8.47333 14.1215 8.96682 14.4978 9.52977 14.4978H15.4779C16.0362 14.4978 16.5268 14.1275 16.68 13.5906L18.4168 7.5H6.58549L7.55906 10.7868C7.56434 10.8046 7.56892 10.8224 7.57283 10.8403Z"
                                fill="#212121"
                            />
                            <path
                                d="M11 19C11 20.1046 10.1046 21 9 21C7.89543 21 7 20.1046 7 19C7 17.8954 7.89543 17 9 17C10.1046 17 11 17.8954 11 19ZM9.5 19C9.5 18.7239 9.27614 18.5 9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19Z"
                                fill="#212121"
                            />
                            <path
                                d="M18 19C18 20.1046 17.1046 21 16 21C14.8954 21 14 20.1046 14 19C14 17.8954 14.8954 17 16 17C17.1046 17 18 17.8954 18 19ZM16.5 19C16.5 18.7239 16.2761 18.5 16 18.5C15.7239 18.5 15.5 18.7239 15.5 19C15.5 19.2761 15.7239 19.5 16 19.5C16.2761 19.5 16.5 19.2761 16.5 19Z"
                                fill="#212121"
                            />
                        </svg>
                        <span className="item-quantity">{cartQuantity}</span>
                    </div>
                </div>
            )}
        </div>
    )
}
